import React from 'react'
import { Accordion, Box, Spinner, Typography } from '@vp/swan'
import { t } from 'i18next'
import FaqCollapsible from './FaqCollapsible'
import { useFaqs } from '../../hooks/useFaqs'

interface Props {
  faqIds: string[] | null | undefined
  tenant: string
  locale: string
  useStaging?: boolean
}

const Faqs: React.FC<Props> = ({ faqIds, tenant, locale, useStaging }) => {
  const lng = locale.toLowerCase().replace('-', '_')
  const { faqResults, isLoadingFaq } = useFaqs(faqIds, locale, tenant, useStaging)

  if (!faqResults) {
    return null
  }
  if (isLoadingFaq) {
    return <Spinner accessibleText={t(`${tenant}:articles.loading`, { lng })} />
  }

  return (
    <Box>
      <Typography fontSkin="title-subsection">{t(`${tenant}:articles.faqs_title`, { lng })}</Typography>
      <Accordion>
        {faqResults.map((faqResult) => (
          <FaqCollapsible key={`faq-key-${faqResult.id}`} faqResult={faqResult} />
        ))}
      </Accordion>
    </Box>
  )
}
export default Faqs
